import axios from "axios";
import BACKEND_URL from "../config";

const transport = axios.create({
    // baseURL: "http://192.168.1.4:8002/api/v1",
    baseURL: BACKEND_URL,
    // 30s ceiling on every request — without this a hanging backend
    // leaves the user staring at a spinner indefinitely (most painful
    // during checkout / payments). Long file ops can override per-call.
    timeout: 30000,
});

transport.interceptors.request.use((config) => {

    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'default';
    config.headers['local'] = currentLanguageCode;

    const cartSessionId = localStorage.getItem('cart_session_id');
    if (cartSessionId) {
        config.headers['X-Cart-Session'] = cartSessionId;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});
transport.interceptors.response.use(
    (response) => {
        // Backend may return the cart session in different shapes. Persist whichever is present
        // so subsequent requests carry the correct X-Cart-Session header and the server
        // resolves the same cart the UI is displaying.
        const sessionId =
            response.data?.meta?.session_id ||
            response.data?.data?.session_id ||
            response.data?.data?.cart?.session_id;
        if (sessionId) {
            localStorage.setItem('cart_session_id', sessionId);
        }
        return response;
    },
    (error) => {
        // معالجة 401 Unauthorized
        if (error.response && error.response.status === 401) {
            const isLoginRequest = error.config.url.includes('/auth/login');
            const isAlreadyOnLoginPage = window.location.pathname === "/login";
            // Opt-out for callers that need to handle 401 themselves
            // (e.g. payment result polling — bouncing the user mid-result
            // to /login is much worse than telling them their session
            // expired and pointing them at /orders).
            const skipRedirect = error.config.skipAuthRedirect === true;

            if (!isLoginRequest && !isAlreadyOnLoginPage && !skipRedirect) {
                console.error("Unauthorized! Redirecting to login...");
                localStorage.removeItem('accessToken');
                localStorage.removeItem('user');
                localStorage.removeItem('abilities');
                window.location.href = "/login";
            }
        }

        // معالجة 429 Too Many Requests (Rate Limiting)
        if (error.response && error.response.status === 429) {
            const retryAfter = error.response.data?.meta?.retry_after;
            console.warn(`Rate limit exceeded. Retry after ${retryAfter} seconds.`);
            // يمكن عرض toast notification هنا
        }

        return Promise.reject(error);
    }
);

export default transport;
